import { useMutation, useQueryClient } from '@tanstack/react-query'
import { signOut } from 'aws-amplify/auth'
import * as React from 'react'

import { sendEvent } from 'src/shared/api/events/send-event'

interface UseSignOutProps {
  isConsumer?: boolean
  isEnterprise?: boolean
}

export const useSignOut = ({ isConsumer = false, isEnterprise = false }: UseSignOutProps = {}) => {
  const queryClient = useQueryClient()
  const [shouldNavigate, setShouldNavigate] = React.useState(false)

  React.useEffect(() => {
    if (shouldNavigate && !isConsumer) {
      window.location.href = isEnterprise ? '/enterprise/login' : '/login'
    }
  }, [shouldNavigate, isConsumer, isEnterprise])

  return useMutation({
    mutationFn: async () => {
      await signOut()
    },
    onSuccess: () => {
      // Clear all query cache data to prevent stale data issues
      queryClient.clear()
      // Trigger navigation through state change
      setShouldNavigate(true)
      sendEvent({ eventType: 'auth_signout' })
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'error',
        info: { error: errorName },
      })
    },
  })
}
